import { createGlobalStyle } from 'styled-components'

/**
 * Disable native iOS time picker to use custom TimePicker component
 */
export const MobileGlobalStyles = createGlobalStyle`
  /* Disable native iOS time picker - applies to all screen sizes for iOS */
  @supports (-webkit-touch-callout: none) {
    /* iOS only */
    input[type='time'] {
      -webkit-appearance: none;
      appearance: none;
      position: relative;
    }

    /* Hide the native time picker button/icon on iOS */
    input[type='time']::-webkit-date-and-time-value {
      text-align: left;
    }

    input[type='time']::-webkit-calendar-picker-indicator {
      display: none;
      -webkit-appearance: none;
      opacity: 0;
      pointer-events: none;
      position: absolute;
      right: 0;
      width: 0;
      height: 0;
    }

    /* Prevent iOS from showing native picker on click */
    input[type='time']::-webkit-inner-spin-button,
    input[type='time']::-webkit-clear-button {
      display: none;
      -webkit-appearance: none;
    }
  }
`
